export default __webpack_public_path__ + "pgnv-assets/80a503c8e3ba1d48b7bbcb2e1ced77db.png";